import { ILossPreventionConfig } from '../useLossPreventionConfig'

export const mwbConfig: ILossPreventionConfig = {
  summary: {
    isVisible: false,
  },
  kpiSettings: [
    { category: 'basic', key: 'totalComps', title: 'Total Discounts' },
    {
      category: 'custom',
      type: 'Deletes',
      title: 'Deletes',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Voids',
      title: 'Voids',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Overrings',
      title: 'Overrings',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Refunds',
      title: 'Refunds',
      key: 'amount',
    },
  ],
  discountByEmployeeTable: {
    display: false,
  },
  cashHandlingTable: {
    display: false,
    columns: [],
  },
  voidsAndDeletesTable: {
    display: false,
    columns: [],
  },
  opsCompsBreakdownTable: {
    display: false,
  },
}
